const getArrayExcludingForbidArray = (allArray, key, forbidValuesArray) => {
	const arrayWithoutForbids = allArray?.filter(
		(x) => !forbidValuesArray.includes(x?.[key])
	)

	return arrayWithoutForbids
}

export default getArrayExcludingForbidArray
